import { Component, ViewChild } from '@angular/core';
import { DataTreeComponent, Node } from '../../../../core/components/data-tree/data-tree.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../../../../core/components/modal/modal.component';
import { SnackbarService } from '@core/services/snackbar.service';
import { DashboardService } from '../../services/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { $Locale } from '@hubio/hubio-common-components';
import { transactionDetailsConfig } from '../../configs/transaction-details.config';

@Component({
  selector: 'app-transaction-details',
  templateUrl: './transaction-details.component.html',
  styleUrls: ['./transaction-details.component.scss']
})
export class TransactionDetailsComponent {
  data;
  config = transactionDetailsConfig;
  @ViewChild(DataTreeComponent, { static: true }) tree: DataTreeComponent;
  public breadcrumbsSteps = [];

  constructor(
    public dialog: MatDialog,
    private snackBarService: SnackbarService,
    private dashboardService: DashboardService,
    private route: ActivatedRoute,
    private router: Router,
    public $Locale: $Locale
  ) { }

  ngOnInit(): void {
    const { transactionAid } = this.route.snapshot.params

    this.dashboardService.getTransactionDetails({ aid: transactionAid }).toPromise().then((transaction) => {
      this.breadcrumbsSteps.push({
        label: this.$Locale.get("files"),
        relativeRoute: "/communic8/"
      })
      if (!transaction) return

      const { transactionDetails, parentDetails } = transaction
      this.data = transactionDetails

      this.breadcrumbsSteps.push({
        label: parentDetails.fileName,
        relativeRoute: this.router.url.split('/broker')[0]
      }, {
        label: parentDetails.agentCode,
        relativeRoute: this.router.url.split('/transaction')[0]
      }, {
        label: parentDetails.transactionCode,
        relativeRoute: this.router.url
      });
    })
  }

  openJsonModal(): void {
    this.dialog.open(ModalComponent, {
      data: {
        title: 'Transaction JSON',
        json: this.data,
        button: {
          label: 'Copy',
          icon: 'filter_none',
          action: this.copyToClipboard.bind(this)
        }
      }
    });
  }

  handleNodeNavigation(node: Node | null) {
    if (!node) {
      document.body.scrollTo({ top: 0, behavior: 'smooth' }); 
    } else {
      this.tree.expandNode(node)
      this.tree.scrollToNode(node)
    }
  }

  private copyToClipboard() {
    const jsonString = JSON.stringify(this.data, null, 2);
    navigator.clipboard.writeText(jsonString).then(_ => {
      this.snackBarService.open('Copied to clipboard')
    })
  }
}
